import { keyframes } from '@emotion/react';

const rotate = keyframes`
   0% { transform: rotate(0deg) }
  100% { transform: rotate(1turn) }
`;

export const styles = {
  Loader: {
    display: 'inline-block',
    border: '2px solid',
    borderRadius: '50%',
    animation: `0.8s infinite ${rotate}`
  }
};
